import $ from 'jquery'

export function getDevice() {
  const viewport = window.innerWidth;
  return viewport > 768 ? 'desktop' : 'mobile';
}

function resizeTrigger(){
    $(window).trigger('device:change', [getDevice()]);
}

$(function(){
  resizeTrigger();
  let resizeTimer:number;
  $(window).on('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        resizeTrigger();
      }, 250);
  } );
});